import type { AdminRole } from '@/lib/api-admin';

/**
 * 홈 팝업 라우트 접근 역할.
 *
 * ★catalog-service `AdminCmsController` 의 `@PreAuthorize("hasAnyRole(SUPER_ADMIN,OPS_ADMIN)")`
 * 와 **정확히 일치**해야 한다. 다른 CMS 화면이 쓰는 CONTENT_ROLES 에는 MD_MANAGER 가 포함되는데,
 * 그 역할로 이 메뉴를 열면 화면은 뜨고 API 만 403 이 나서 원인을 알기 어려운 실패가 된다.
 */
export const HOME_POPUP_ROUTE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];
